import { Link } from 'react-router-dom'
import './house.css'

function House({house}) {
    return (
        <div className='house' id='#homes'>
            <img src={house.img} alt=''/>
            <h3 className='houseTitle'>{house.title}</h3>
            <div className='houseDesc'>
                <p><b>Location:</b> {house.location}</p>
                <p><b>Rent per/month:</b>{`Ksh=/ ${house.cost}`}</p>
            </div>
              <Link to={`/room/${house._id}`} className='link'><button className='houseBtn'>View & Rent</button></Link>  
        </div>
    )
   
}

export default House
